var cibCmake = ["32 32", "<path d='M15.693 0.088l-15.605 30.855 17.016-14.459zM30.943 31.912l-20.979-8.464-9.964 8.464zM32 31.645l-15.604-31.025 2.292 25.651zM17.193 17.281l-6.704 5.729 7.495 2.995z'/>"];

export { cibCmake };

